import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-two-lesson-seven-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitTwoLessonSevenGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 2, Lesson 7 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 7: Action Plan for Employment and Education";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
